import { useState } from "react";
import { bursariesApi } from "../api/hliLists";
import { Container, PageHeader, Select } from "./ui";
import LoanRequestsTable from "./bursaries/LoanRequestsTable";
import { useStudyAreaOptions, useYearState } from "./bursaries/shared";

// The HLI admin grants or rejects their institution's bursary requests, by year and study area
export default function HliAdminLoanView() {
  const [year, setYear, years] = useYearState();
  const [studyArea, setStudyArea] = useState("");
  const studyAreas = useStudyAreaOptions();

  return (
    <Container className="flex flex-col gap-6 py-6">
      <PageHeader
        title="Loan Approval"
        subtitle="Your students' bursary requests; the student sees your decision straight away"
        actions={
          <div className="flex flex-wrap gap-3">
            <Select aria-label="Study area" placeholder="All study areas" value={studyArea} onChange={(e) => setStudyArea(e.target.value)} options={studyAreas} className="w-56" />
            <Select aria-label="Academic year" value={year} onChange={(e) => setYear(e.target.value)} options={years} className="w-44" />
          </div>
        }
      />
      {year && (
        <LoanRequestsTable
          list={bursariesApi.myRequests}
          decide={bursariesApi.decideMine}
          params={{ academicYearId: year, ...(studyArea && { studyArea }) }}
          exportName={`bursary-requests${studyArea ? `-${studyArea}` : ""}`.replace(/\s+/g, "-")}
        />
      )}
    </Container>
  );
}
